import axios from 'axios';
import { GENERAL_ERROR} from '../constants';
import store from '../store';
import {HTTP_METHOD, ROOT_API_URL} from "../constants/http";

axios.defaults.headers.post.Accept = 'application/json';
axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.request.use(config => {
  const accessToken = localStorage.getItem('accessToken');
  if (accessToken) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

const getAxiosOptions = (uri, payload, method, additionalOptions) => {
  const url = new URL(ROOT_API_URL + uri);
  const options = {
    url,
    method,
    ...additionalOptions,
  };

  if (/^GET$/i.test(method)) {
    Object.entries(payload || {})
      .map(([key, value]) => url.searchParams.set(key, value));
  } else {
    options.data = payload;
  }

  return options;
};

const generalError = (payload = 'Something went wrong') => store.dispatch({
  type: GENERAL_ERROR,
  payload,
});

export const callApi = async (
  uri,
  payload,
  onSuccess,
  onError,
  method = HTTP_METHOD.POST,
  additionalOptions = {},
) => {
  try {
    const options = getAxiosOptions(uri, payload, method, additionalOptions);
    const {
      data,
      status,
    } = await axios(options);
    onSuccess(data, status);
  } catch ({ response }) {
    if (!response) {
      generalError();
      return;
    }

    const { status, data } = response;
    if (status >= 500) {
      generalError(data.error);
      return;
    }

    onError(data, status);
  }
};
